/* eslint-disable */
import authService from "../services/auth-service";
export default {
  state: {
    user: {
      token: localStorage.getItem("token"),
      fullname: localStorage.getItem("fullname"),
      email: localStorage.getItem("email")
    }
  },
  mutations: {
    updateUser(state, user) {
      state.user.token = user.token;
      state.user.fullname = user.fullname;
      state.user.email = user.username;
      state.user.refreshToken = user.refreshToken;
      authService.setStorage(user);
    },
    logout(state) {
      state.user.token = null;
      state.user.fullname = null;
      state.user.email = null;
      state.user.refreshToken = null;
      authService.removeStorage();
      location.href = "/";
    }
  },
  actions: {
    async login(context, { email, password }) {
      context.dispatch("toggleLoading");
      try {
        var response = await authService.login(email, password);
        context.commit("updateUser", response.data);
      } catch (err) {
        throw err;
      } finally {
        context.dispatch("toggleLoading");
      }
    },

    async register(context, { fullname, email, password }) {
      context.dispatch("toggleLoading");
      try {
        var response = await authService.register(fullname, email, password);
        context.commit("updateUser", response.data);
      } catch (err) {
        throw err;
      } finally {
        context.dispatch("toggleLoading");
      }
    },

    logout(context) {
      context.commit("logout", context.state.user);
    }
  }
};
